module.exports = __webpack_public_path__ + "addeparStep2PortfolioPrefix.bd1f1add13b0c66c9dacec620af281fa.png";